/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_ALL_CARTS = gql`
  query GetAllCarts {
    getAllCarts {
      _id
      referal
      totalAmount
      user {
        id
        email
      }
      presentation {
        id
        name
      }
      section {
        id
        name
      }
      items {
        quantity
        featurePrice
        valuePrice
        costumeType {
          id
          name
          minDownPayment
        }
        costumeFeature {
          id
          name
          isBase
        }
        costumeAttribute {
          id
          name
        }
        costumeValue {
          id
          minDownPayment
          topupPrice
          name
        }
      }
    }
  }
`;
